module.exports = __webpack_public_path__ + "static/img/product_images_37_h5_zh.6efed26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product_images_37_h5_zh.png
// module id = SxmS
// module chunks = 34